<template>
	<div class="intro font-archivo flex flex-wrap mb-20">
		<div class="w-full lg:w-1/2 mb-4">
			<h6 class="font-barlow text-orange uppercase font-bold mb-4">{{ subtitle }}</h6>
			<h1 class="text-4xl font-bold">{{ title }}</h1>
		</div>
		<div class="w-full lg:w-1/2 lg:mt-12 text-xl">
			<slot></slot>
		</div>
	</div>
</template>

<script>

export default {
	props: ['title', 'subtitle']
}

</script>